import { trialDaysLeft } from "@/utils/iap/trial-days";
import { isDev } from "@/utils/debug/is-dev";
import { getDaysUsed } from "@/utils/user/first-run-timestamp";

import pmUserProfessionDialog from "@/components/dialogs/user-profession";

const messages = [

    // {
    //     subject: '',
    //     text: '',
    //     condition: () => {

    //     }
    // },

    // {
    //     id: 'smart-video-v2',
    //     img: '/images/onboarding/e-learning.jpg',
    //    // mdi: 'mdiPlayCircleOutline',
    //     subject: localStorage.getItem("smartVideoViewed") ? 'Watch again the SMART tutorial' : 'Resume the SMART tutorial',
    //     text: 'Watch this short video on how to use DentiCalc SMART.',
    //     condition: () => {
    //         return localStorage.getItem("smartVideoClosed") || localStorage.getItem("smartVideoViewed");
    //     },
    //     callback: () => {
    //         app.$bus.$emit('openAppDialog','videoDialog');
    //     },
    // },

    // {
    //     id: 'welcome',
    //     subject: 'Welcome, Doctor',
    //     img: '/images/onboarding/onboarding-logo.jpg',
    //     text: 'Here you will find tips on how to get the most out of using DentiCalc...',
    //     condition: () => {
    //         return true;
    //     },
    //     callback: () => {
    //         app.$bus.$emit('openAppDialog', 'welcomeMessage');
    //     },
    // },

    // {
    //     id: 'e-learning',
    //     img: '/images/onboarding/e-learning.jpg',
    //     subject: 'Invitation for Webinar',
    //     fullsubject: '',
    //     text: 'Discover the finest parts of DentiCalc in a video onboarding session!',
    //     fulltext: 'We would be happy to help you in discovering the finest parts of DentiCalc in a video onboarding session.<br/><br/><a class="message-button" href="https://www.youtube.com/channel/UCPUuvd0w4408xBstDhjzP8Q">Follow our YouTube channel</a>',
    //     condition: () => {
    //         return true;
    //     },
    // },

    // {
    //     id: 'user-profession',
    //     subject: 'Let us know you better!',
    //     text: 'In order to provide you the best possible services please choose...',
    //     condition: () => {
    //         return (localStorage.getItem('appDashboardOpenCounter') && localStorage.getItem('appDashboardOpenCounter') >= 10);
    //     },
    //     callback: () => {
    //         app.$bus.$emit('openAppDialog', 'userProfession');
    //     },
    // },

    {
        id: 'rate-us',
        // mdi: 'starOutline',
        subject: 'How are WE doing?',
        text: 'We are working to make DentiCalc the best dental app, ever. Tell us...',
        condition: () => {
            return (localStorage.getItem('appDashboardOpenCounter') && localStorage.getItem('appDashboardOpenCounter') >= 20);
        },
        callback: () => {
            app.$bus.$emit('openAppDialog','review');
        },
    },

    {
        id: 'tutorial-videos',
        subject: 'One minute tutorials',
        text: 'Discover DentiCalc effortlessly with our short tutorial videos',
        condition: () => {
            return (localStorage.getItem('appDashboardOpenCounter') && localStorage.getItem('appDashboardOpenCounter') >= 2);
        },
        callback: () => {
            app.$router.push("/tutorials");
        },
    },

    {
        id: 'faq',
        subject: 'F.A.Q.',
        text: 'Frequently asked questions from dentists worldwide using DentiCalc',
        condition: () => {
            return (localStorage.getItem('appDashboardOpenCounter') && localStorage.getItem('appDashboardOpenCounter') >= 2);
        },
        callback: () => {
            app.$router.push("/faq");
        },
    },

    // {
    //     id: 'special-offer',
    //     mdi: 'mdiSale',
    //     subject: 'PREMIUM Special Offer',
    //     text: 'Your free trial is about to expire. Don\'t lose the benefits of DentiCalc PREMIUM. Be more profitable & have more free time.',
    //     condition: () => {
    //         return (trialDaysLeft() <= 1 && localStorage.getItem('appDashboardOpenCounter') && localStorage.getItem('appDashboardOpenCounter') >= 10)
    //     },
    //     callback: () => {
    //         app.$bus.$emit('openAppDialog','premium', { 'title': '', 'referrer': 'click_messages_offer'});
    //     }
    // },
    // {
    //     id: 'ad-001',
    //     mdi: 'mdiAlertDecagramOutline',
    //     subject: 'Revolutionary Implant Type',
    //     ad: true,
    //     fullsubject: 'Example advert title',
    //     text: 'Bredent™ just made available a new implant type which...',
    //     fulltext: 'Example advert image & text',
    // },


   /* {
        id: 'brgihtplans-ad-0001',
        mdi: 'mdiAlertDecagramOutline',
        subject: 'BrightPlans - 14 days FREE trial',
        ad: false,
        fullsubject: 'Create professional treatment plans that will be clear and understandable to your patients.',
        text: 'Create professional treatment plans with fully personalized 3D animations.',
        fulltext: 'Example advert image & text',
        callback: () => {
            app.$router.push('/brightplans');
        }
    },*/


    // {
    //     id: 'test1',
    //     mdi: 'mdiTrophyOutline',
    //     img: '/images/onboarding/award.jpg',
    //     subject: 'New achievement - well done!',
    //     fullsubject: 'New achievement<br/>Well done!',
    //     text: 'You\'ve created your first plan with SMART. It was easy, wasn\'t it?',
    //     fulltext: 'You\'ve created your <b>first plan</b> with SMART. It was easy, wasn\'t it?<br/><br/><em><b>DID YOU KNOW?</b><br/><br/>You can customize prices or add new treatments to your pricelist in the Settings menu.</em>',
    //     condition: () => {
    //         return (localStorage.getItem('smartTreatmentSelectedCounter') && localStorage.getItem('smartTreatmentSelectedCounter') >= 1);
    //     },
    // },



]


const messageStatus = {

}

const getDefaultMessageStatus = () => {
    return {
        shown: Date.now(),
        read: 0,
    }
}

const storeMessageStatus = () => {
    localStorage.setItem('inAppMessageStatus', JSON.stringify(messageStatus));
}

const loadMessageStatus = () => {
    const data = localStorage.getItem('inAppMessageStatus');
    if (data) Object.assign(messageStatus, JSON.parse(data));
}

export const setMessageReadStatus = (message) => {
    const t = Date.now();

    if(messageStatus[message.id].read > 0) return;

    messageStatus[message.id].read = t;
    message.read = t;
    storeMessageStatus();

    window.Tracker.logEvent({
        event_name: "open",
        event_category: "in-app-messages",
        event_label: message.id,
    });
}

export const getMessages = () => {
    loadMessageStatus();

    const items = messages.filter(message => {
        return (typeof messageStatus[message.id] !== "undefined" || !message.condition || message.condition())
    });

    items.forEach(message => {
        if (typeof messageStatus[message.id] === "undefined") {
            messageStatus[message.id] = getDefaultMessageStatus();
        }

        Object.assign(message, messageStatus[message.id]);
    });

    return items.sort(sortMessages);
}

const sortMessages = (a, b) => {
    if (a.shown < b.shown) return 1;
    if (a.shown > b.shown) return -1;
    return 0;
}

export const countUnreadMessages = () => {
    getMessages();
    return Object.values(messageStatus).filter((item) => (!item.read)).length;
}
